var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-6774 -620 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-1 {\n        stroke: #000;\n        stroke-linejoin: round;\n        stroke-miterlimit: 10;\n        stroke-width: 1.5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2411",
    "data-name": "Gruppe 2411",
    transform: "translate(-11 -6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2406",
    "data-name": "Gruppe 2406",
    transform: "translate(-7583 -623.8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_93",
    "data-name": "Rechteck 93",
    className: "cls-1",
    width: 36.8,
    height: 24,
    transform: "translate(832 33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_162",
    "data-name": "Pfad 162",
    className: "cls-1",
    d: "M837.3,21.8h26.2L868.8,33H832Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    className: "cls-1",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(835.2 37)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_94",
    "data-name": "Rechteck 94",
    className: "cls-1",
    width: 9.6,
    height: 6.4,
    transform: "translate(856 36.2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_95",
    "data-name": "Rechteck 95",
    className: "cls-1",
    width: 9.6,
    height: 6.4,
    transform: "translate(856 47.4)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_19",
    "data-name": "Linie 19",
    className: "cls-1",
    y2: 16,
    transform: "translate(843.2 37)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_20",
    "data-name": "Linie 20",
    className: "cls-1",
    x1: 11.4,
    y2: 11.4,
    transform: "translate(837.5 39.3)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_21",
    "data-name": "Linie 21",
    className: "cls-1",
    x1: 16,
    transform: "translate(835.2 45)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_22",
    "data-name": "Linie 22",
    className: "cls-1",
    x1: 11.4,
    y1: 11.4,
    transform: "translate(837.5 39.3)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_353",
    "data-name": "Gruppe 353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_352",
    "data-name": "Gruppe 352"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_163",
    "data-name": "Pfad 163",
    d: "M859.2,38.6a.8.8,0,1,0,.8.8.86.86,0,0,0-.8-.8Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_355",
    "data-name": "Gruppe 355"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_354",
    "data-name": "Gruppe 354"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_164",
    "data-name": "Pfad 164",
    d: "M862.4,38.6a.8.8,0,1,0,.8.8.86.86,0,0,0-.8-.8Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_357",
    "data-name": "Gruppe 357"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_356",
    "data-name": "Gruppe 356"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_165",
    "data-name": "Pfad 165",
    d: "M859.2,49.8a.8.8,0,1,0,.8.8.86.86,0,0,0-.8-.8Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_359",
    "data-name": "Gruppe 359"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_358",
    "data-name": "Gruppe 358"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_166",
    "data-name": "Pfad 166",
    d: "M862.4,49.8a.8.8,0,1,0,.8.8.86.86,0,0,0-.8-.8Z"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1327",
    "data-name": "Rechteck 1327",
    className: "cls-2",
    width: 60,
    height: 60,
    transform: "translate(-6763 -614)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter1);
export default __webpack_public_path__ + "static/media/filter1.36cbeb63c315948304045c7be648f8b0.svg";
export { ForwardRef as ReactComponent };